import Dialog from '@mui/material/Dialog'

import { Button } from '../../../UI'

const TopUpSuccess = ({ open, onContinue, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      classes={{
        paper: 'md:!max-w-[420px] !p-[24px] !rounded-[12px] !bg-[#FEEBDD] !shadow-modal-light',
      }}
    >
      <div className="w-full flex flex-col items-center justify-center">
        <img src="/assets/image/top-up-success.svg" alt="Success" width={124} height={124} />

        <h2 className="mt-[16px] text-xl font-bold text-primary-100 text-center">
          Top Up Successful
        </h2>

        <h3 className="mt-[8px] text-sm font-medium text-primary-100 text-center">
          Your balance has been updated.
        </h3>

        <div className="p-[20px] w-full flex flex-col items-start rounded-[10px] border-[#FFE4D4] border-[1px] bg-white mt-[16px]">
          <div className="w-full flex items-center justify-between">
            <span className="text-sm text-primary-100 font-medium">Your balance:</span>

            {/* TODO */}
            <span className="text-base text-primary-100 font-bold">€ 50</span>
          </div>
        </div>

        <Button
          type="button"
          onClick={onContinue}
          className="w-full text-lg font-semibold mt-[24px]"
        >
          Continue
        </Button>
      </div>
    </Dialog>
  )
}

export default TopUpSuccess
